var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch, store, } from '../../../store';
import { updateIsActiveChatPanel } from '../../../store/slices/bottomIconsActivitySlice';
const isActiveChatPanelSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveChatPanel);
$RefreshReg$(_react_refresh_temp_1, "isActiveChatPanelSelector$createSelector");
const totalUnreadChatMsgsSelector = createSelector(_react_refresh_temp_2 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.totalUnreadChatMsgs);
$RefreshReg$(_react_refresh_temp_2, "totalUnreadChatMsgsSelector$createSelector");
const ChatIcon = () => {
    _react_refresh_temp_4();
    const dispatch = useAppDispatch();
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const { t } = useTranslation();
    const isActiveChatPanel = useAppSelector(isActiveChatPanelSelector);
    const totalUnreadChatMsgs = useAppSelector(totalUnreadChatMsgsSelector);
    const [iconCSS, setIconCSS] = useState('primaryColor');
    const [allowChat, setAllowChat] = useState(true);
    useEffect(() => {
        if (isActiveChatPanel) {
            setIconCSS('secondaryColor');
        }
        else {
            setIconCSS('primaryColor dark:text-darkText');
        }
    }, [isActiveChatPanel]);
    useEffect(() => {
        var _a;
        const metadata = store.getState().session.currentRoom
            .metadata;
        if (!((_a = metadata.room_features) === null || _a === void 0 ? void 0 : _a.chat_features.allow_chat)) {
            setAllowChat(false);
            dispatch(updateIsActiveChatPanel(false));
        }
    }, [dispatch]);
    const toggleChatPanel = () => {
        dispatch(updateIsActiveChatPanel(!isActiveChatPanel));
    };
    const render = () => {
        return (_jsxs("div", { className: `message footer-icon h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] relative rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleChatPanel(), children: [_jsx("span", { className: "tooltip", children: isActiveChatPanel
                        ? t('footer.icons.hide-chat-panel')
                        : t('footer.icons.show-chat-panel') }), _jsx("i", { className: `pnm-chat ${iconCSS} text-[14px] lg:text-[16px]` }), !isActiveChatPanel && totalUnreadChatMsgs > 0 ? (_jsx("div", { className: "unseen-message-count bg-brandRed w-5 h-5 rounded-full text-xs text-white absolute -top-2 -right-1 flex justify-center items-center", children: totalUnreadChatMsgs })) : null] }));
    };
    return _jsx(_Fragment, { children: allowChat ? render() : null });
};
_react_refresh_temp_3 = ChatIcon;
$RefreshReg$(_react_refresh_temp_3, "ChatIcon");
_react_refresh_temp_4(ChatIcon, "eMbK/jb82iCC++GFsdaahJIUuH4=", false, () => [useAppDispatch, useTranslation, useAppSelector, useAppSelector]);
export default ChatIcon;
